// const CNPJ_LENGTH = 14
const CNPJ_BASE_LENGTH = 12
const CNPJ_REGEX = /^[A-Z0-9]{12}[0-9]{2}$/
const CNPJ_ZEROS = '00000000000000'

const DV1_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
const DV2_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

const charValue = (char) => char.charCodeAt(0) - 48

const checkDigit = (chars, weights) => {
  let sum = 0
  for (let i = 0; i < weights.length; i++) {
    sum += charValue(chars[i]) * weights[i]
  }
  const mod = sum % 11
  return mod < 2 ? 0 : 11 - mod
}

export const strip = (value) => {
  if (!value) return ''
  return String(value)
    .toUpperCase()
    .replace(/[.\-/]/g, '')
}

export const isValid = (value) => {
  const stripped = strip(value)

  if (!CNPJ_REGEX.test(stripped)) return false
  if (stripped === CNPJ_ZEROS) return false

  const base = stripped.substring(0, CNPJ_BASE_LENGTH)
  const dvInformado = stripped.substring(CNPJ_BASE_LENGTH)

  const dv1 = checkDigit(base, DV1_WEIGHTS)
  const dv2 = checkDigit(base + dv1, DV2_WEIGHTS)
  const dvCalculado = `${dv1}${dv2}`

  return dvInformado === dvCalculado
}
